import type { ProviderAdditionalStep } from "services/paymentApi.types";

export const ADDITIONAL_STEP_MODAL_TITLE = "Configurações";
export const ADDITIONAL_STEP_MODAL_SUBTITLE = "Configurações do provedor";

export function hasProviderAdditionalStep(
  step?: ProviderAdditionalStep | null | string,
): boolean {
  if (step == null) {
    return false;
  }

  if (typeof step === "string") {
    return step.trim().length > 0;
  }

  return Object.values(step).some(
    (value) => value != null && String(value).trim() !== "",
  );
}

export function normalizeProviderAdditionalStep(
  step?: ProviderAdditionalStep | null | string,
): ProviderAdditionalStep | null {
  if (!hasProviderAdditionalStep(step)) {
    return null;
  }

  if (typeof step === "string") {
    return { linkLabel: step.trim() };
  }

  return step ?? null;
}

function getAdditionalStepLinkValue(step: ProviderAdditionalStep): string {
  const url = (step.url ?? step.redirectUrl ?? "").trim();
  const linkLabel = step.linkLabel?.trim();
  const linkText = step.linkText?.trim();

  if (linkLabel) {
    return linkLabel;
  }

  if (linkText) {
    return linkText;
  }

  if (url) {
    return url;
  }

  const nestedStep = (step as { additionalSteps?: unknown }).additionalSteps;
  if (typeof nestedStep === "string" && nestedStep.trim()) {
    return nestedStep.trim();
  }

  return "";
}

export function resolveAdditionalStepContent(step: ProviderAdditionalStep) {
  return {
    linkLabel: getAdditionalStepLinkValue(step),
    messageSuffix: step.message?.trim() ?? "",
  };
}

export function buildAdditionalStepNoticeMarkdown(
  linkLabel: string,
  messageSuffix: string,
): string {
  return [linkLabel.trim(), messageSuffix.trim()].filter(Boolean).join(" ");
}
